import "core-js/modules/es6.regexp.split";
import moment from 'moment';
export var DateMixin = {
  data: function data() {
    return {
      aDayTime: 1000 * 60 * 60 * 24,
      // 一天的毫秒
      aWeekTime: 1000 * 60 * 60 * 24 * 7,
      // 一周的毫秒
      dateTime: '',
      // 年 - 月 -日
      monthTime: '',
      // 年 - 月
      yearTime: '',
      // 年份
      weekYear: '',
      // 年 - 周
      quarterYear: '',
      // 年
      quarterMonths: '',
      // 季度
      startYear: '',
      //年开始
      endYear: '',
      //年结束
      startWeek: '',
      //周开始
      endWeek: '' //周结束

    };
  },
  created: function created() {
    var time = new Date();
    this.dateTime = this.moment(time);
    this.weekYear = this.moment(time);
    this.monthTime = this.moment(time);
    this.quarterYear = time.getFullYear();
    this.quarterMonths = Math.ceil((time.getMonth() + 1) / 3);
    this.yearTime = time.getFullYear();
    this.startYear = time.getFullYear() - 1;
    this.endYear = time.getFullYear();
    var date = new Date();
    date.setTime(date.getTime() - this.aWeekTime);
    this.startWeek = this.moment(date);
    this.endWeek = this.moment(time);
  },
  methods: {
    moment: moment,
    // 日 格式化：年月日
    dateFormatFun: function dateFormatFun(val) {
      return moment(val).format('YYYY-MM-DD');
    },
    // 日 格式化：月日
    dateFormatFun2: function dateFormatFun2(val) {
      return moment(val).format('MM-DD');
    },
    // 周 格式化 ： [年，周]
    weekFormatFun: function weekFormatFun(val) {
      var date = new Date(val);
      return [date.getFullYear(), this.getWeek(date)];
    },
    // 周 格式化 ： 年-周
    weekFormatFunStr: function weekFormatFunStr(val) {
      var date = new Date(val);
      return date.getFullYear() + '-' + this.getWeek(date);
    },
    // 周 格式化 ： 周
    weekFormatFunStr2: function weekFormatFunStr2(val) {
      var date = new Date(val);
      return this.getWeek(date);
    },
    // 月 格式化 ： 年-月
    monthFormatFun: function monthFormatFun(val) {
      return moment(val).format('YYYY-MM');
    },
    // 月 格式化 ： 月
    monthFormatFun2: function monthFormatFun2(val) {
      return moment(val).format('MM');
    },
    // 上一天
    prevDay: function prevDay() {
      var date = new Date();
      date.setTime(new Date(this.dateTime).getTime() - this.aDayTime);
      this.dateTime = moment(date);
      this.$emit("change", this.dateFormatFun(this.dateTime));
    },
    // 下一天
    nextDay: function nextDay() {
      var date = new Date();
      date.setTime(new Date(this.dateTime).getTime() + this.aDayTime);
      this.dateTime = moment(date);
      this.$emit("change", this.dateFormatFun(this.dateTime));
    },
    // 上一周
    prevWeek: function prevWeek() {
      var date = new Date();
      date.setTime(new Date(this.weekYear).getTime() - this.aWeekTime);
      this.weekYear = moment(date);
      this.$emit('change', this.weekFormatFun(this.weekYear));
    },
    // 下一周
    nextWeek: function nextWeek() {
      var date = new Date();
      date.setTime(new Date(this.weekYear).getTime() + this.aWeekTime);
      this.weekYear = moment(date);
      this.$emit('change', this.weekFormatFun(this.weekYear));
    },
    // 获取上个月日期
    getPrevMonth: function getPrevMonth(date) {
      var arr = date.split('-');
      var year = arr[0]; //获取当前日期的年份

      var month = arr[1]; //获取当前日期的月份

      var day = arr[2]; //获取当前日期的日

      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数

      var year2 = year;
      var month2 = parseInt(month) - 1;

      if (month2 == 0) {
        year2 = parseInt(year2) - 1;
        month2 = 12;
      }

      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();

      if (day2 > days2) {
        day2 = days2;
      }

      if (month2 < 10) {
        month2 = '0' + month2;
      }

      var t2 = year2 + '-' + month2 + '-' + day2;
      return t2;
    },
    // 获取下个月日期
    getNextMonth: function getNextMonth(date) {
      var arr = date.split('-');
      var year = arr[0]; //获取当前日期的年份

      var month = arr[1]; //获取当前日期的月份

      var day = arr[2]; //获取当前日期的日

      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中的月的天数

      var year2 = year;
      var month2 = parseInt(month) + 1;

      if (month2 == 13) {
        year2 = parseInt(year2) + 1;
        month2 = 1;
      }

      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();

      if (day2 > days2) {
        day2 = days2;
      }

      if (month2 < 10) {
        month2 = '0' + month2;
      }

      var t2 = year2 + '-' + month2 + '-' + day2;
      return t2;
    },
    // 上个月
    prevMonth: function prevMonth() {
      var month = this.getPrevMonth(moment(this.monthTime).format('YYYY-MM-DD'));
      this.monthTime = moment(month);
      this.$emit('change', this.monthFormatFun(this.monthTime));
    },
    // 下个月
    nextMonth: function nextMonth() {
      var month = this.getNextMonth(moment(this.monthTime).format('YYYY-MM-DD'));
      this.monthTime = moment(month);
      this.$emit('change', this.monthFormatFun(this.monthTime));
    },
    // 获取上个季度日期
    getPrevQuarter: function getPrevQuarter(year, quarter) {
      if (year == '2017' && quarter == '1') {
        var quarters = quarter;
      } else {
        var quarters = quarter - 1;
      }

      var years = year;

      if (quarters < 1) {
        quarters = 4;

        if (years > 2017) {
          years--;
        }
      }

      return [years, quarters];
    },
    // 获取下个季度日期
    getNextQuarter: function getNextQuarter(year, quarter) {
      var quarters = parseInt(quarter) + 1;
      var years = year;

      if (quarters > 4) {
        quarters = 1;

        if (years < 2116) {
          years++;
        } else {
          years = 2017;
        }
      }

      return [years, quarters];
    },
    // 上个季度
    prevQuarter: function prevQuarter() {
      var date = this.getPrevQuarter(this.quarterYear, this.quarterMonths);
      this.quarterYear = date[0];
      this.quarterMonths = date[1];
      this.$emit('change', date);
    },
    // 下个季度
    nextQuarter: function nextQuarter() {
      var date = this.getNextQuarter(this.quarterYear, this.quarterMonths);
      this.quarterYear = date[0];
      this.quarterMonths = date[1];
      this.$emit('change', date);
    },
    // 上一年
    prevYear: function prevYear() {
      this.yearTime--;

      if (this.yearTime < 2017) {
        this.yearTime = 2017;
      }

      this.$emit('change', this.yearTime);
    },
    // 下一年
    nextYear: function nextYear() {
      this.yearTime++;

      if (this.yearTime > 2116) {
        this.yearTime = 2017;
      }

      this.$emit('change', this.yearTime);
    },
    // 获取第几周
    getWeek: function getWeek(dateTime) {
      var year = new Date(dateTime).getFullYear();
      var month = new Date(dateTime).getMonth() + 1;
      var date = new Date(dateTime).getDate();
      var dateNow = new Date(year, parseInt(month) - 1, date);
      var dateFirst = new Date(year, 0, 1);
      var dataNumber = Math.round((dateNow.valueOf() - dateFirst.valueOf()) / 86400000);
      return Math.ceil((dataNumber + (dateFirst.getDay() + 1 - 1)) / 7);
    }
  }
};